import { Button } from "@/components/ui/button";

const Register = () => {
    return (
        <>
            <section className="bg-pink-900 py-16 px-4">
                <div className="max-w-3xl mx-auto text-center text-white">
                    <h2 className="text-3xl font-heading font-semibold mb-6">
                        Ready to Experience the Axent Difference?
                    </h2>
                    <p className="text-xl mb-8">
                        Let's talk. We'd love to show you how Axent can help you grow.
                    </p>
                    <div className="flex flex-col sm:flex-row justify-center gap-4">
                        <a href="https://online.axentbrokers.com/system/agent-register.aspx" target="_blank" rel="noopener noreferrer">
                            <Button variant="outline"
                                className="text-2xl bg-white text-black hover:bg-neutral-100 cursor-pointer">Register for an Agency</Button>
                        </a>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Register;
